// src/pages/Private/Admin/AdminTeachers.js
import { useState, useEffect } from 'react';
import { getAllTeachers } from '../../../services/adminService';
import './AdminTeachers.css';

function AdminTeachers() {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    loadTeachers();
  }, []);

  const loadTeachers = async () => {
    try {
      setLoading(true);
      const data = await getAllTeachers();
      setTeachers(data);
    } catch (err) {
      setError('Error loading teachers');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const filteredTeachers = teachers.filter(teacher =>
    teacher.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    teacher.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
    teacher.branch?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="admin-teachers">
      <h1>Teacher Management</h1>
      
      <div className="teachers-header">
        <input
          type="text"
          placeholder="Search teachers..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        <button className="add-btn">➕ Add Teacher</button>
      </div>

      {error && <div className="error">{error}</div>}

      <div className="teachers-grid">
        {filteredTeachers.map(teacher => (
          <div key={teacher._id} className="teacher-card">
            <div className="teacher-avatar">
              {teacher.name.charAt(0)}
            </div>
            <h3>{teacher.name}</h3>
            <p>{teacher.email}</p>
            <p className="branch">{teacher.branch || 'No branch specified'}</p>
            <p className="experience">{teacher.experience || 'No experience specified'}</p>
            <div className="teacher-actions">
              <button className="edit-btn">✏️</button>
              <button className="delete-btn">🗑️</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AdminTeachers;